export const AUDIENCES = {
  LOCAL: 'Local insights - Host Community',
  NATIONAL: 'National insights - Opinion Leaders',
};

export const HOST_COMMUNITY = 'Host Community';
